import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

function nameLink (userId, actor) {
  if (userId === actor.id) {
    return (
      <a href={`/profile/${userId}`}>
        <FormattedMessage id='feed.story.like.self' defaultMessage='You' />
      </a>
    )
  }

  return (
    <a href={`/profile/${actor.id}`}>
      {actor.title}
    </a>
  )
}

export function LikeCopy ({ likes, userId }) {
  return (
    <div>
      {likes && likes.items.length === 1 ?
        <div>
          {userId === likes.items[0].actor.id ?
            <FormattedMessage
              id='feed.story.liketext.1'
              defaultMessage='{person} liked this'
              values={{
                person: <a href={`/profile/${likes.items[0].actor.id}`}>You</a>,
              }} />
          :
            <FormattedMessage
              id='feed.story.liketext.you'
              defaultMessage={'{person} liked this'}
              values={{
                person: nameLink(userId, likes.items[0].actor),
              }} />
          }
        </div>
      : null}

      {likes && likes.items.length === 2 ?
        <FormattedMessage
          id='feed.story.liketext.2'
          defaultMessage='{person1} and {person2} liked this'
          values={{
            person1: nameLink(userId, likes.items[0].actor),
            person2: nameLink(userId, likes.items[1].actor),
          }} />
      : null}

      {likes && likes.items.length > 2 ?
        <FormattedMessage
          id='feed.story.liketext.multiple'
          defaultMessage='{person1}, {person2}, and {otherCount} more liked this'
          values={{
            person1: nameLink(userId, likes.items[0].actor),
            person2: nameLink(userId, likes.items[1].actor),
            otherCount: (likes.count - 2),
          }} />
      : null}
    </div>
  )
}

LikeCopy.propTypes = {
  likes: PropTypes.object,
  userId: PropTypes.number,
}

export default LikeCopy
